import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 247px;
  height: 208px;
  > span > div {
    height: 100%;
    width: 100%;
  }
`

interface IImageProps {
  url: string
}

export const Image = styled.div<IImageProps>`
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center center;
  background-color: #ccc;
  border-radius: 4px;
  height: 100%;
  transition: 200ms;
`

export const ChangeImage = styled.div`
  transition: 0.2s;
  opacity: 0;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  svg {
    padding: 10px;
    height: 20px;
    border-radius: 50% !important;
    background-color: rgba(33, 63, 104, 0.75) !important;
    color: white !important;
    transition: 0.2s;
    :hover {
      background-color: rgba(33, 63, 104, 1) !important;
    }
  }
`

interface IContainerProps {
  imageloaded: string
}

export const Container = styled.div<IContainerProps>`
  text-align: center;
  ${(props) =>
    props.imageloaded === 'false' &&
    css`
      border: 2px dashed #d9d9d9;
    `}
  border-radius: 4px;
  height: 100%;
  cursor: pointer;
  transition: 200ms;
  &:hover {
    > div + div {
      opacity: 1;
    }
    ${(props) =>
      props.imageloaded === 'false' &&
      css`
        border-color: #2684ff;
      `}
  }
`

export const Content = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  button {
    margin-top: 5px;
    color: #2684ff;
    font-weight: 700;
  }
`

export const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin: 0 auto;
  svg {
    background-color: white;
    border-radius: 8px;
    color: #757575;
    padding: 10px;
    height: 20px;
  }
`

export const Title = styled.div`
  margin-top: 16px;
  color: #757575;
`

export const Subtitle = styled.div`
  color: #757575;
`
